import { Injectable } from "@angular/core";
import { Language, Mote, SimpleTranslationMap, SupportedLanguage, TranslationMap } from "@motes-sdk/models";

@Injectable({ providedIn: 'root' })

export class LanguageService {

    /**
     * Filter duplicate tours by extracting the preferred translation for each collection of translations
     */
    public static filterMotesByLocale(motes: Mote[], locale: string): Mote[] {
        if(motes?.length <= 0) return [];
        let translationMap = LanguageService.getTranslationMap(motes);
        return LanguageService.filterTranslationByLocale(translationMap, locale);
    }

    /**
     * Group motes by their originKey, and list their languages
     */
    public static getTranslationMap(motes: Mote[]): TranslationMap {
        let map = {};
        motes.forEach((mote) => {
            // OriginKey belongs to the mote of original language (if null, then key = originKey)
            let originKey = mote?.originKey || mote?.key;
            // Add mote originKey to map if it is not there already
            if(!map[originKey]) map[originKey] = [];
            // Add corresponding mote to originKey
            map[originKey].push(mote);
        });
        return map;
    }

    /**
     * Group mote (language and key) by their originKey, and list their languages
     */
    public static getSimpleTranslationMap(motes: Mote[]): SimpleTranslationMap {
        let map = {};
        motes.forEach((mote) => {
            // OriginKey belongs to the mote of original language (if null, then key = originKey)
            let originKey = mote?.originKey || mote?.key;
            // Add mote originKey to map if it is not there already
            if(!map[originKey]) map[originKey] = [];
            // Add corresponding mote to originKey
            map[originKey].push({ language: mote.language, moteKey: mote.key });
        });
        return map;
    }

    private static filterTranslationByLocale(translationMap: TranslationMap, locale: string): Mote[] {
        return Object.values(translationMap).map((translations) => LanguageService.getMoteMatchingLocale(translations, locale));
    }

    private static getMoteMatchingLocale(translations: Mote[], locale: string): Mote {
        // Map tours by their language
        let tourTranslationMap = {};
        translations.forEach((mote) => tourTranslationMap[mote.language] = mote)

        // Match supported languages with tour translations (as we might not have a supported language for every tour language)
        switch(locale) {
            case SupportedLanguage.en: return tourTranslationMap[Language.en] || tourTranslationMap[Language.da] || tourTranslationMap[Language.sv] || tourTranslationMap[Language.de] || translations[0];
            case SupportedLanguage.da: return tourTranslationMap[Language.da] || tourTranslationMap[Language.sv] || tourTranslationMap[Language.en] || tourTranslationMap[Language.de] || translations[0];
            default: console.warn('The locale with which you tried to filter your mote duplicates is not supported.');
        }
    }
}
